import { TreeMapDownloadDataButton } from './TreeMapDownloadDataButton.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { A11yToolbarTabIndex } from '../../../core/types/toolbar.js';
import { DEFAULT_TOOLBAR_PLACEMENT } from '../../constants.js';
import { useToolbarConfig } from '../../context/ToolbarContext.js';
import { useTreeMapRawData } from '../../context/TreeMapRawDataContext.js';
import { useToolbar } from '../../hooks/useToolbar.js';
import { useTooltip } from '../../hooks/useTooltip.js';
import { useOverlayState } from '../../store/selectors.js';
import { buildAndDownloadCsv } from '../../utils/build-and-download-csv.js';

export const TreeMapToolbar = () => {
  const toolbarConfig = useToolbarConfig();
  const { mouseInBounds } = useOverlayState();
  const { setTooltipPinned } = useTooltip();
  const { setTooltipHoverState } = useToolbar();
  const toolbarPlacement =
    toolbarConfig?.placement ?? DEFAULT_TOOLBAR_PLACEMENT;

  const handleMouseEnter = () => {
    setTooltipHoverState(true);
    setTooltipPinned(false);
  };

  const handleMouseLeave = () => {
    setTooltipHoverState(false);
  };

  const isDownloadEnabled = toolbarConfig?.downloadData?.enabled ?? false;
  const { tree } = useTreeMapRawData();

  /** Handles the download button when clicked. */
  const handleDownloadDataToolbar = () => buildAndDownloadCsv(tree);

  const showDefaultToolbarDownloadButton =
    isDownloadEnabled && !toolbarConfig?.intents;

  const initialA11yState: A11yToolbarTabIndex[] =
    showDefaultToolbarDownloadButton ? [{ download: 0 }] : [{ intent: 0 }];

  return (
    <ChartToolbarRenderer
      visible={mouseInBounds}
      placement={toolbarPlacement}
      collapsed={toolbarConfig?.collapsed}
      draggable={toolbarConfig?.draggable}
      initialA11yState={initialA11yState}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      menuDisplayMode={'never'}
      isDownloadEnabled={isDownloadEnabled}
      intents={toolbarConfig?.intents}
      handleDownloadDataToolbar={handleDownloadDataToolbar}
      DownloadButton={() => <TreeMapDownloadDataButton />}
    >
      {showDefaultToolbarDownloadButton && <TreeMapDownloadDataButton />}
    </ChartToolbarRenderer>
  );
};
